import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import '../styles/featuredpracticesection.css';

const data = [
  {
    category: 'Medical & Healthcare',
    title: 'Adult CCRN',
    description: 'Prepare for the Adult CCRN exam with comprehensive, real-world practice questions designed to strengthen your critical care nursing knowledge and boost your certification success.',
    questions: 1881,
    icon: '📘',
  },
  {
    category: 'Medical & Healthcare',
    title: 'Medical Assistant Exam',
    description: 'Master the Medical Assistant Exam with realistic practice questions covering clinical, administrative, and procedural skills to help you pass with confidence.',
    questions: 1000,
    icon: '📘',
  },
  {
    category: 'Medical & Healthcare',
    title: 'PTCB Exam',
    description: 'Prepare for the Pharmacy Technician Certification Exam (PTCE) with comprehensive practice questions focused on medications, pharmacy operations, and safety standards.',
    questions: 885,
    icon: '💊',
  },
  /* {
    category: 'Medical & Healthcare',
    title: 'Next Generation NCLEX-RN: Pediatric Nursing',
    description: 'Strengthen your pediatric nursing skills with NGN-style NCLEX-RN practice questions covering child health, growth and development, and family-centered care.',
    questions: 1881,
    icon: '🧸',
  },
    {
    category: 'Medical & Healthcare',
    title: 'Next Generation NCLEX-RN: Maternity Nursing',
    description: 'Prepare for the NGN NCLEX-RN Maternity Nursing exam with practice questions on prenatal care, labor, delivery, and postpartum nursing to boost your clinical readiness.',
    questions: 1881,
    icon: '🤰',
  },
  {
    category: 'Medical & Healthcare',
    title: 'USMLE Step 1: Behavioral Science and Social Sciences',
    description: 'Master the behavioral and social sciences for USMLE Step 1 with high-yield practice questions on ethics, communication, psychology, and patient behavior.',
    questions: 1881,
    icon: '🧠',
  }, */
  {
    category: 'IT Certifications',
    title: 'CompTIA Security+ (SY0 701)',
    description: 'Prepare for the CompTIA Security+ exam with hands-on practice questions covering network security, risk management, cryptography, and threat mitigation.',
    questions: 2722,
    icon: '🔒',
  },
  {
    category: 'IT Certifications',
    title: 'CompTIA Linux+ (XK0-006)',
    description: 'Prepare for the CompTIA Linux+ (XK0-006) exam with practical questions on System Management, Services and User Management, Security, and Automation, Orchestration and Scripting.',
    questions: 2722,
    icon: '📊',
  },
  {
    category: 'Education & Teaching',
    title: 'FTCE Art K-12',
    description: 'Prepare for the FTCE Art K-12 exam with comprehensive practice questions covering Two-Dimensional Art Processes, Three-Dimensional Art Processes, Digital Arts, Art History and Culture, and much more.',
    questions: 1245,
    icon: '🌎',
  },
  {
    category: 'Education & Teaching',
    title: 'FTCE Physical Education K-12',
    description: 'Prepare for the FTCE Physical Education K-12 exam with practice questions covering Physical Education Instructional Strategies, Movement Skills and Physical Education Concepts, and much more.',
    questions: 2029,
    icon: '🗣️',
  },
/*   {
    category: 'Education & Teaching',
    title: 'FTCE Elementary Education K–6 (060)',
    description: 'Prepare for the FTCE Elementary Education K–6 (060) exam with detailed practice questions covering reading, math, science, and social studies to strengthen your teaching foundations.',
    questions: 1000,
    icon: '🏫',
  },
  {
    category: 'Education & Teaching',
    title: 'FTCE Agriculture 6-12 (054)',
    description: 'Prepare for the FTCE Agriculture 6–12 (054) exam with targeted practice questions on agricultural science, environmental systems, animal and plant production, and agribusiness concepts.',
    questions: 1000,
    icon: '🌾',
  }, */
  /* {
    category: 'Professional',
    level: 'Advanced',
    title: 'IC85 Reinsurance Management',
    description: 'Project Management Professional certification practice questions.',
    questions: 10,
    time: '15 Minutes',
    icon: '👔',
  },
  {
    category: 'Professional',
    level: 'Advanced',
    title: 'IC38 Life Insurance Agent Exam',
    description: 'Certified Information Systems Security Professional test prep.',
    questions: 10,
    time: '20 Minutes',
    icon: '🛡️',
  },
  {
    category: 'Professional',
    level: 'Intermediate',
    title: 'IC 89 Management Accounting',
    description: 'Amazon Web Services certification practice questions.',
    questions: 10,
    time: '15 Minutes',
    icon: '☁️',
  },
  {
    category: 'Language',
    level: 'Intermediate',
    title: 'IC 14 Regulations of Insurance Business',
    description: 'Test of English as a Foreign Language practice questions.',
    questions: 10,
    time: '20 Minutes',
    icon: '📄',
  }, */
  {
    category: 'Professional',
    title: 'NASM Certified Personal Trainer',
    description: 'Prepare for the NASM Certified Personal Trainer (CPT) exam with comprehensive, exam-focused practice questions designed to build strong foundational knowledge, enhance applied training skills, and boost certification success.',
    questions: 1973,
    icon: '🏋️‍♂️',
  },
];

const tabs = ['Medical & Healthcare', 'IT Certifications', 'Education & Teaching','Professional'];

export default function FeaturedPracticeSection() {
  const [activeTab, setActiveTab] = useState('Medical & Healthcare');
  const navigate = useNavigate();

  // validate localStorage login and auto-clear if expired
  const itemStr = localStorage.getItem('isLogin');
  let item = null;
  try {
    item = itemStr ? JSON.parse(itemStr) : null;
    const now = new Date();
    if (!itemStr || (item && item.expiry < now.getTime())) {
      localStorage.clear();
      item = null;
    }
  } catch (e) {
    localStorage.clear();
    item = null;
  }

  const filteredData =
    activeTab === 'All Categories' ? data : data.filter((it) => it.category === activeTab);

  // helper to show warning when not logged in
  const showLoginWarning = () => {
    message.warning('You need to Log in or Sign up to get Started!', 3);
  };

  // Start Practice handler
  // const handleStartPractice = (title) => {
    
  //   if (item && item.expiry && item.expiry > Date.now()) {
      
  //     const slug = title.replace(/\s+/g, '-');
  //     navigate(`/online-practice-test/${slug}`, { state: { type: "category-test" } });
  //   } else {
  //     showLoginWarning();
  //   }
  // };

  const handleStartPractice = (title) => {
    
    
      
      const catName = title.toLowerCase();
      console.log(catName);
      navigate(`/practice-test-exam-prep/${catName.toLowerCase().replace(/\s+/g, '-').replace(/\(|\)/g, '')}`, { state: { type: "category-test" } });
    
  };

  return (
    <div className="featured-section">
      <h2>Featured Practice Exams</h2>
      <p>Choose from our collection of expertly-crafted practice tests designed to help you prepare for your upcoming exams.
       </p>
       <p>
        Boost your exam success with our expertly designed mock tests, practice exams, and timed quizzes covering IT 
        certifications, medical & healthcare exams, business and finance, language proficiency, and more. 
        Access realistic questions, detailed explanations, and track your performance to prepare effectively and build exam 
        confidence.</p>
      

      <div className="tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tab-button ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="cards-container">
        {filteredData.map((itemData, idx) => (
          <div className="card" key={idx}>
            <div className="card-header">
              <span className="icon">{itemData.icon}</span>
              <div className="labels">
                <span className="badge-card category">{itemData.category}</span>
                {/* <span className="badge level">{itemData.level}</span> */}
              </div>
            </div>
            <h3>{itemData.title}</h3>
            <p>{itemData.description}</p>
            <div className="info">
              <span>🕒 {itemData.questions} Questions</span>
              {/* <span>⏱️ {itemData.time}</span> */}
            </div>
            <button
              className="start-button"
              onClick={() => handleStartPractice(itemData.title)}
            >
              Start Practice
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
